import axios from "../util/payrightAxios";
import moment  from "moment";
import {
    FETCH_LOANS_BEGIN,
    FETCH_LOANS_SUCCESS,
    FETCH_LOANS_FAILURE,
    CLEAR_SELECTED_LOAN,
    SET_SELECTED_LOAN
} from '../actions/types';

export function fetchLoans() {

    return (dispatch, getState) => {

        const customerId = getState().auth.customerId == null ? localStorage.getItem('customerId') : getState().auth.customerId;
        const authToken = getState().auth.authToken == null ? localStorage.getItem('authToken') : getState().auth.authToken;

        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const url = `${apiBaseUrl}/customer/${customerId}/loans`;
        axios.defaults.headers.common['auth-token'] = authToken


        dispatch(fetchLoansBegin());
        return axios({
            url: url,
            method: "get",
        })
            .then(response => {
                let loans = response.data.data.loans;
                const loansObject = loans.map(loansData => {
                    const loansDataCustomise = {
                        'ID': loansData.ID,
                        'loanName': { 'name': loansData.loanName.name, 'ref': loansData.loanName.ref },
                        'status': loansData.status,
                        'paidLoanAmount': loansData.paidLoanAmount,
                        'balanceRemaining': loansData.balanceRemaining,
                        'nextRepaymentDate': loansData.nextRepaymentDate ? moment(loansData.nextRepaymentDate).format("DD MMM YYYY"): null,
                        'loanViewButtonUrl': 'Yes',
                        'principal': loansData.principal,
                        'interest': loansData.interest,
                        'payoutAmount': loansData.payoutAmount
                    }
                    return loansDataCustomise;
                });
                dispatch(fetchLoansSuccess(loansObject));
                return loansObject;
            })
            .catch(error => {
                dispatch(fetchLoansFailure(error));
            });

    }
}

export const fetchLoansBegin = () => ({
    type: FETCH_LOANS_BEGIN
});

export const fetchLoansSuccess = loans => ({
    type: FETCH_LOANS_SUCCESS,
    payload: { loans }
});

export const fetchLoansFailure = error => ({
    type: FETCH_LOANS_FAILURE,
    payload: { error },
});

export const clearSelectedLoan = () => ({
    type: CLEAR_SELECTED_LOAN
})

export const setSelectedLoan = (loan) => ({
    type: SET_SELECTED_LOAN,
    payload: { loan }
})